export default __webpack_public_path__ + "static/media/file-upload-24-px.449daf5e.svg";